import React from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { BackButton } from "../../../../components";
import { Dumpster } from "../../../../models";
import { getDumpsters } from "../../dumpstersSlice";
import { DumpsterMap } from "../../components/DumpsterMap/DumpsterMap";

import "./DumpstersMapView.scss";

export function DumpstersMapView() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const dumpsters = useAppSelector((state) => state.dumpsters.dumpsters) || [];
  const getDumpstersAPI = useAppSelector(
    (state) => state.dumpsters.getDumpsters
  );

  React.useEffect(() => {
    // with_coordinates enriches order-located dumpsters with customer name +
    // order lat/lng for the map pins.
    dispatch(getDumpsters({ withCoordinates: true }));
  }, [dispatch]);

  React.useEffect(() => {
    if (!getDumpstersAPI.loading && getDumpstersAPI.error) {
      toast.error("Failed to load dumpsters. Please try again.");
    }
  }, [getDumpstersAPI.loading, getDumpstersAPI.error]);

  const orderDumpsters = React.useMemo(
    () => dumpsters.filter((d: Dumpster) => d.locationType === "order"),
    [dumpsters]
  );

  return (
    <div className="dumpsters-map-view">
      <div className="map-view-header">
        <BackButton onClick={() => navigate("/dumpsters")} />
        <h2>
          Dumpster Map
          <span className="count">({orderDumpsters.length})</span>
        </h2>
      </div>
      <div className="map-view-body">
        <DumpsterMap dumpsters={orderDumpsters} />
      </div>
    </div>
  );
}
